import { Link } from 'react-router-dom';
import { useI18n } from '@/i18n';

/**
 * The next live release, shown as a single banner. Kept as data so swapping the
 * headline title, art or target date is a one-line edit.
 */
const FEATURED = {
  title: 'Thunder Roulette',
  description:
    'Multiplier drops land on straight-up numbers every spin, built on the Royal Roulette studio wheel.',
  image: '/banners/thunder.webp',
  /** Written out rather than derived, so the roadmap can promise a loose date. */
  targetDate: '20 April 2027',
  href: '/library?category=live',
};

export function RoadmapBanner() {
  const { t } = useI18n();

  return (
    <section className="roadmap-banner site-pad-x" aria-label={t('roadmap.bannerAria')}>
      <div className="roadmap-banner__media" aria-hidden="true">
        <img className="roadmap-banner__art" src={FEATURED.image} alt="" loading="eager" />
        <span className="roadmap-banner__scrim" />
      </div>

      <div className="roadmap-banner__copy">
        <p className="eyebrow roadmap-banner__eyebrow">{t('nav.comingSoon')}</p>
        <h2 className="roadmap-banner__title display">{FEATURED.title}</h2>
        <p className="roadmap-banner__lead">{FEATURED.description}</p>
        <div className="roadmap-banner__actions">
          <span className="roadmap-banner__target">
            {t('roadmap.target', { date: FEATURED.targetDate })}
          </span>
          <Link to={FEATURED.href} className="btn btn-primary roadmap-banner__cta">
            {t('home.openLibrary')}
          </Link>
        </div>
      </div>

      <div className="hero-split" aria-hidden="true" />
    </section>
  );
}
